import { useEffect, useCallback, useState } from 'react';

export const useAfterResize = (callback, immediately = true, ms = 100) => {
  if (!callback) {
    throw new Error('useAfterResize requires a callback function');
  }
  const [timer, setTimer] = useState(null);
  const [initialized, setInitialized] = useState(!immediately);
  const handleTimer = useCallback(() => {
    callback();
    clearTimeout(timer);
    setTimer(null);
  }, [timer, callback]);
  const handleResize = useCallback(() => {
    if (timer) {
      clearTimeout(timer);
    }
    const newTimer = setTimeout(handleTimer, ms);
    setTimer(newTimer);
  }, [timer, handleTimer, ms]);

  useEffect(() => {
    if (!initialized) {
      setTimeout(handleResize, 0);
      setInitialized(true);
    }

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [initialized, timer, ms, handleResize]);
};
